export default defineAppConfig({
  // This file exists for the purpose of setting the default UI configs for NuxtUI components
  ui: {
    colors: {
      // Default color for everything
      primary: 'primary',
      secondary: 'secondary',
      primaryDefault: 'brand-secondary',
      neutral: 'zinc'
    },

    // Default USkeleton color
    skeleton: {
      base: 'bg-primary-500/15'
    },

    // Default button configuration
    button: {
      base: 'transition-all ease-in-out duration-400',
    },

    // Default inputs border color (gray-200)

    // Override the ring-(--municipality-border-accented) default border color class for inputs, inputMenu, select, and selectMenu
    input: {
      variants: {
        variant: {
          outline: 'text-(--municipality-text-highlighted) bg-white ring ring-inset ring-gray-300',
          subtle: 'text-(--municipality-text-highlighted) bg-white ring ring-inset ring-gray-300'
        }
      }
    },
    inputMenu: {
      variants: {
        variant: {
          outline: 'text-(--municipality-text-highlighted) bg-white ring ring-inset ring-gray-300',
          subtle: 'text-(--municipality-text-highlighted) bg-white ring ring-inset ring-gray-300'
        }
      }
    },
    select: {
      variants: {
        variant: {
          outline: 'text-(--municipality-text-highlighted) bg-white ring ring-inset ring-gray-300',
          subtle: 'text-(--municipality-text-highlighted) bg-white ring ring-inset ring-gray-300'
        }
      }
    },
    selectMenu: {
      variants: {
        variant: {
          outline: 'text-(--municipality-text-highlighted) bg-white ring ring-inset ring-gray-300',
          subtle: 'text-(--municipality-text-highlighted) bg-white ring ring-inset ring-gray-300'
        }
      }
    },
  }
})